/*
 * Cart fail-safe (v2 — slide-cart-agnostic).
 *
 * Problem: clicking the header cart button intermittently does NOTHING for some customers
 * (the cart UI — a 3rd-party slide cart and/or the theme drawer — fails to open). v1 watched
 * only the theme drawer, so when a 3rd-party slide cart opened instead, it wrongly navigated.
 *
 * v2 does NOT assume any specific cart UI. After a cart-button click it watches for ANY sign
 * that a cart surface opened — a slide/drawer/modal becoming visible, the background getting
 * scroll-locked, a state class flipping, or focus moving into something. Only if, after a full
 * 2s, NONE of those happened (i.e. genuinely nothing opened) does it send the customer to /cart
 * so they're never stranded. Heavily biased against false-positives.
 */
(function () {
  'use strict';

  var CART_URL = (window.Shopify && Shopify.routes && Shopify.routes.root)
    ? (Shopify.routes.root + 'cart').replace('//', '/')
    : '/cart';
  var WAIT_MS = 2000;

  // Fingerprint of "is some cart/drawer/modal surface currently open?"
  function snapshot() {
    var overlays = 0;
    var candidates = document.querySelectorAll(
      '[class*="drawer" i],[class*="cart" i],[class*="slide" i],[class*="mini-cart" i],' +
      '[class*="modal" i],[class*="flyout" i],[role="dialog"],[aria-modal="true"],aside,dialog'
    );
    for (var i = 0; i < candidates.length && i < 500; i++) {
      var el = candidates[i];
      var cs = window.getComputedStyle(el);
      if ((cs.position === 'fixed' || cs.position === 'absolute') &&
          cs.display !== 'none' && cs.visibility !== 'hidden' &&
          parseFloat(cs.opacity || '1') > 0.1) {
        var r = el.getBoundingClientRect();
        // a real cart surface is a sizeable panel that's actually on screen
        if (r.width >= 200 && r.height >= 200 &&
            r.left < window.innerWidth && r.right > 0 && r.top < window.innerHeight && r.bottom > 0) {
          overlays++;
        }
      }
    }
    var b = window.getComputedStyle(document.body);
    var h = window.getComputedStyle(document.documentElement);
    return {
      overlays: overlays,
      locked: b.overflow === 'hidden' || h.overflow === 'hidden' || b.position === 'fixed',
      bodyCls: document.body.className,
      htmlCls: document.documentElement.className,
      active: document.activeElement
    };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.site-header-cart--button, [data-cart-drawer-toggle]');
    if (!btn) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return; // let modified clicks behave normally

    var before = snapshot();

    window.setTimeout(function () {
      if (document.visibilityState === 'hidden') return; // tab not in foreground — don't redirect
      var after = snapshot();

      var openedSomething =
        after.overlays > before.overlays ||                 // a slide/drawer/modal appeared
        (after.locked && !before.locked) ||                 // background scroll got locked
        after.bodyCls !== before.bodyCls ||                 // a state class flipped on <body>
        after.htmlCls !== before.htmlCls ||                 // ...or on <html>
        (document.activeElement && document.activeElement !== before.active &&
         document.activeElement !== document.body);          // focus moved into the cart UI

      if (openedSomething) return; // cart opened fine — do nothing

      // Genuinely nothing happened — don't leave the customer stuck.
      if (window.Sentry && Sentry.captureMessage) {
        try {
          Sentry.captureMessage('Cart did not open on click — fail-safe redirected to /cart', {
            level: 'error',
            tags: { feature: 'cart', failsafe: 'v2' },
            extra: {
              overlaysBefore: before.overlays, overlaysAfter: after.overlays,
              userAgent: navigator.userAgent,
              scripts: Array.prototype.slice.call(document.scripts).map(function (s) { return s.src; }).filter(Boolean)
            }
          });
        } catch (e2) {}
      }
      window.location.href = CART_URL;
    }, WAIT_MS);
  }, true); // capture phase: snapshot reflects the true pre-click state
})();
